// Что ответил сервер на запрос компании по id:
//   "failed"   запрос не удался или ответ не прочитался (это показывает LoadError),
//   "notfound" сервер ответил, но такой компании нет (не было или её удалили),
//   "found"    компания есть.
export const lookupOf = (response) => {
  if (!response || response.error) return "failed";
  return Array.isArray(response.payload) && response.payload.length > 0 ? "found" : "notfound";
};
